import { loadStripe } from "@stripe/stripe-js";
import SetupFormManageSubscription from "./SetupFormManageSubscription";
import { useEffect, useState } from "react";
import { Elements } from "@stripe/react-stripe-js";

// const setStripeKey = () => {
//   switch (true) {
//     case window.location.hostname.includes("dev01"):
//       return "pk_test_51MRIbtHhMwnaPpvCUiHSNuCx33e1PbhRgtGA77k5f9tUgKe03BvOhdYvbUIQg0OHWpPVt8On7YU8LfLSkkmAgDFc00UpSc5bN1";
//     default:
//       return "pk_live_51MRIbtHhMwnaPpvCMCoKHKzVLzeucPksZgrIYMSStkOdrxXkLIrHYOtmhON1b1mG4jLZzY3DxNh8sFLl1JTBAkXk00XDnTfqLF";
//   }
// };
//
// const stripePromise = loadStripe(setStripeKey());

export default function StripeP() {
  const [clientSecret, setClientSecret] = useState(null);
  const appearance = {
    theme: "stripe",
  };
  const options = {
    // passing the client secret obtained in step 3
    clientSecret,
    // Fully customizable with appearance API.
    appearance,
  };
  const authUser = JSON?.parse(localStorage?.getItem("authUser"));
  const [stripePromiseAPI, setStripePromiseAPI] = useState(null);
  useEffect(() => {
    // Create PaymentIntent as soon as the page loads
    fetch(
      "https://api2.crmit.co.uk/ci-4-jwt/public/masterpaymentcard/stripe/setupintent",
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${authUser?.token}`,
        },
        // body: JSON?.stringify(companyData),
      }
    )
      .then((res) => res.json())

      .then((data) => {
        setClientSecret(data.client_secret);
        setStripePromiseAPI(data?.stripe_pk);
      });
  }, []);

  const stripePromise =
    stripePromiseAPI !== null && loadStripe(stripePromiseAPI);

  return (
    <>
      {clientSecret && stripePromise && (
        <Elements stripe={stripePromise} options={options}>
          <SetupFormManageSubscription />
        </Elements>
      )}
    </>
  );
}
